export function fmt(n: number): string {
  if (n == null || isNaN(n)) return "-";
  return n.toLocaleString("ja-JP");
}
